import * as React from 'react';
import { observer } from 'mobx-react';
import { Grid, GridColumn, Notice, TGridColumnWidth } from 'telia-front-react';
import useStores from '../stores/UseStores';
import { isSmallModuleView } from '../util/ModuleUtil';

const NoticeAuthUpgrade = (): React.JSX.Element | null => {
  const {
    translateStore: { translate },
    homeStore: { homeResponse },
    uiStore: { componentWidth },
  } = useStores();

  if (!homeResponse.params?.upgradeAuth) {
    return null;
  }

  const gridWidth: TGridColumnWidth[] = [`md-${isSmallModuleView(componentWidth) ? '10' : '8'}`, 'xs-12'];

  return (
    <Grid align={[isSmallModuleView(componentWidth) ? 'start-md' : 'center-md']}>
      <GridColumn width={gridWidth}>
        <Notice size="small" align="center">
          {translate('auth.level.upgradeNeeded')}
        </Notice>
      </GridColumn>
    </Grid>
  );
};

export default observer(NoticeAuthUpgrade);
